// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../../fetch.pb.js";
export var FieldType_Enum;
(function (FieldType_Enum) {
    FieldType_Enum["UNSPECIFIED"] = "UNSPECIFIED";
    FieldType_Enum["URI"] = "URI";
})(FieldType_Enum || (FieldType_Enum = {}));
export var FieldType_Enum_index;
(function (FieldType_Enum_index) {
    FieldType_Enum_index[FieldType_Enum_index["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    FieldType_Enum_index[FieldType_Enum_index["URI"] = 1] = "URI";
})(FieldType_Enum_index || (FieldType_Enum_index = {}));
export const API = {
    /**
     * Gets the configuration for the level of hierarchy specified by the primitive_type and primitive_id.
     */
    GetConfig(fn, req) {
        try {
            fm.validateUrlParam(req["primitiveType"], "primitiveType");
            fm.validateUrlParam(req["primitiveId"], "primitiveId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone/devices/config/${req["primitiveType"]}/${req["primitiveId"]}?${fm.renderURLSearchParams(req, ["primitiveType", "primitiveId"])}`, { method: "GET" });
    },
    /**
     * Updates the configuration for the level of hierarchy specified by the primitive_type and primitive_id.
     */
    UpdateConfig(fn, req) {
        try {
            fm.validateUrlParam(req["primitiveType"], "primitiveType");
            fm.validateUrlParam(req["primitiveId"], "primitiveId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone/devices/config/${req["primitiveType"]}/${req["primitiveId"]}`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * Gets the resolved configuration for a primitive by traversing the hierarchy and merging the configurations.
     */
    ResolveConfig(fn, req) {
        try {
            fm.validateUrlParam(req["primitiveType"], "primitiveType");
            fm.validateUrlParam(req["primitiveId"], "primitiveId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone/devices/config/${req["primitiveType"]}/${req["primitiveId"]}/resolved?${fm.renderURLSearchParams(req, ["primitiveType", "primitiveId"])}`, { method: "GET" });
    },
    /**
     * Gets the list of fields that can be configured for a device.
     * At this point we only support URI fields for a device background, but intend to support more in the future.
     */
    GetFields(fn, req) {
        return fn(`/phone/devices/config/fields?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
};
